import { useQuery } from "@tanstack/react-query";
import { getClients } from "api/client.api";
import { gracefulList } from "lib/queryHelpers";
import { DEFAULT_STALE_TIME } from "config/constants";
import { QUERY_KEYS } from "config/queryKeys";

const normalizeClients = (data) => {
  const clients = data?.clients || data?.data?.clients || data?.data || [];

  if (!Array.isArray(clients)) return [];

  return clients.map((client) => ({
    ...client,
    id: client.id || client._id,
    name:
      client.name ||
      client.clientName ||
      client.businessName ||
      "Unnamed Client",
  }));
};

export const useGetPaymentClients = () => {
  return useQuery({
    queryKey: QUERY_KEYS.clients.list(),
    queryFn: gracefulList(getClients, { clients: [] }),
    select: normalizeClients,
    staleTime: DEFAULT_STALE_TIME,
  });
};
